/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';
import SocialShare from './SocialShare';

Vue.component('ui-social-share', SocialShare);

